import styled from 'styled-components';

const VoteContainer = styled.div`
  border-left: 4px solid rgba(0, 0, 0, 0.12);
  padding-left: 16px;
  margin-top: 42px;
`;

export default VoteContainer;
